export const phoneNumberPattern = /^[0-9]{3}[-][\s/]{0,1}[0-9]{3}[-][\s/]{0,1}[0-9]{4}$/;
export const emailPattern: RegExp = /^[^@]+@\w+(\.\w+)+\w$/;